// let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
//   console.log(items)
//   items.forEach(item => {
//     item.addEventListener("mouseover", () => {
//       item.setAttribute("open", true);
//       item.querySelector("ul").addEventListener("mouseleave", () => {
//         item.removeAttribute("open");
//       });
//     item.addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });
//   });
  
//   });


  document.addEventListener('DOMContentLoaded', function() {
    const listViewBtn = document.getElementById('list-view');
    const gridViewBtn = document.getElementById('grid-view');
    const productGrid = document.querySelector('.product-grid');
  
    const savedView = localStorage.getItem('collectionView') || 'grid';
    setView(savedView);
  
    listViewBtn.addEventListener('click', () => {
      setView('list');
    });
  
    gridViewBtn.addEventListener('click', () => {
      setView('grid');
    });
  
    document.addEventListener('keydown', function(event) {
      if (document.activeElement.tagName !== 'INPUT' && 
          document.activeElement.tagName !== 'TEXTAREA' &&
          !document.activeElement.isContentEditable) {
        
        if (event.key.toLowerCase() === 'l') {
          setView('list');
        }
        else if (event.key.toLowerCase() === 'g') {
          setView('grid');
        }
      }
    });
  
    function setView(view) {
      listViewBtn.classList.toggle('active', view === 'list');
      gridViewBtn.classList.toggle('active', view === 'grid');
  
      if (view === 'list') {
        productGrid.classList.add('list-view');
      } else {
        productGrid.classList.remove('list-view');
      }
  
      localStorage.setItem('collectionView', view);
    }
  });


  document.addEventListener('DOMContentLoaded', function () {
    function setupPasswordToggle(buttonSelector, inputSelector) {
        const toggleButton = document.querySelector(buttonSelector);
        const passwordInput = document.querySelector(inputSelector);

        if (toggleButton && passwordInput) {
            toggleButton.addEventListener('click', function () {
                const isPasswordVisible = passwordInput.type === 'text';
                passwordInput.type = isPasswordVisible ? 'password' : 'text';

                // Update the SVG icon
                const svg = this.querySelector('svg');
                if (svg) {
                    svg.innerHTML = isPasswordVisible
                        ? `<path d="M14 8.5C14 10.1569 12.6569 11.5 11 11.5C9.34315 11.5 8 10.1569 8 8.5C8 6.84315 9.34315 5.5 11 5.5C12.6569 5.5 14 6.84315 14 8.5Z" stroke="#161616" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                           <path d="M11.0004 1.5C6.52281 1.5 2.73253 4.44288 1.45825 8.49997C2.73251 12.5571 6.52281 15.5 11.0005 15.5C15.4781 15.5 19.2684 12.5571 20.5426 8.50004C19.2684 4.44291 15.4781 1.5 11.0004 1.5Z" stroke="#161616" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`
                        : `<path d="M14 8.5C14 10.1569 12.6569 11.5 11 11.5C9.34315 11.5 8 10.1569 8 8.5C8 6.84315 9.34315 5.5 11 5.5C12.6569 5.5 14 6.84315 14 8.5Z" stroke="#161616" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                           <path d="M11.0004 1.5C6.52281 1.5 2.73253 4.44288 1.45825 8.49997C2.73251 12.5571 6.52281 15.5 11.0005 15.5C15.4781 15.5 19.2684 12.5571 20.5426 8.50004C19.2684 4.44291 15.4781 1.5 11.0004 1.5Z" stroke="#161616" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                           <path d="M2 2L20 15" stroke="#161616" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`;
                }

                // Add accessibility attributes
                this.setAttribute('aria-label', isPasswordVisible ? 'Show password' : 'Hide password');
            });

            // Set initial accessibility attributes
            toggleButton.setAttribute('aria-label', 'Show password');
        }
    }

    // Initialize for both password fields
    setupPasswordToggle('.show-password-login', '#CustomerPassword');
    setupPasswordToggle('.show-password-register', '#RegisterForm-password');
});


// Function to trigger click on selected quantity option
// Function to trigger click on selected quantity option
function triggerQuantitySelectorClick() {
  const Qntselectors = document.querySelectorAll('.quantity-option');
  if (Qntselectors.length > 0) {
    Qntselectors[0].click();
  }
}

// Set up MutationObserver to detect changes in the CartDrawer
const cartDrawer = document.querySelector('#CartDrawer');
if (cartDrawer) {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        // Call your function when drawer content updates
        triggerQuantitySelectorClick();
      }
    }
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}

$(document).ready(function() {
    const Qntselector = document.querySelector('.quantity-option:first-child');
  if (Qntselector) {
    Qntselector.click();
  }
});



function getVariantIdFromUrl() {
  const url = new URL(window.location.href);
  const variantId = url.searchParams.get('variant');
  return variantId;
}

function selectMatchingQuantityOption() {
  const variantId = getVariantIdFromUrl();
  if (!variantId) return;

  const selector = document.querySelector(`input[name="quantity_${variantId}"]`);
  if (selector) {
    selector.click(); // This triggers any associated event listeners

    // Optional: ensure 'selected' class is visually updated
    document.querySelectorAll('.quantity-option').forEach(option => {
      option.classList.remove('selected');
    });

    const parentLabel = selector.closest('.quantity-option');
    if (parentLabel) {
      parentLabel.classList.add('selected');
    }
  }
}



$(document).ready(function() {
  selectMatchingQuantityOption();
});







